import { runOwsRequestWithMonitor, FolderGroupType, ContactFolder, Feature } from '../../shared';
import { ContactFolderResponse, getServiceAsync } from '../../service';

export interface CreateFolderExpectedError {
    alreadyExists: boolean;
}

export function isCreateFolderExpectedError(
    object: ContactFolder | CreateFolderExpectedError
): object is CreateFolderExpectedError {
    return 'alreadyExists' in object;
}

export function createFolder(
    rootFolderId: string,
    newFolderName: string
): Promise<ContactFolder | CreateFolderExpectedError> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'CreateFolder',
            feature: Feature.FolderManagement,
            operation: () =>
                service.Operation.createContactFolderOperation({
                    parentFolderId: service.Factory.folderId({ Id: rootFolderId }),
                    displayName: newFolderName,
                    priority: FolderGroupType.userCreatedFolder,
                }),
            transformResponse: (response: ContactFolderResponse) => {
                if (response.ResponseCode === 'ErrorFolderExists') {
                    return { alreadyExists: true };
                }

                return {
                    displayName: newFolderName,
                    id: response.FolderId.Id,
                    children: [],
                    isReadOnly: false,
                    group: FolderGroupType.userCreatedFolder,
                };
            },
        })
    );
}
